/**
 * ## How to create a new parameter ? Part 1
 *
 * First of all, you need to identify what is the type of your new parameter.\
 * To do so, you have to ask you : "In what form my parameter will be saved ?"\
 * Now depending on your answer you have multiple choices :
 *  * "My parameter will be saved as a number" : See {@link Src/Parameters/Numeric.LisioNumericParameter | LisioNumericParameter}
 *  * "My parameter will be saved as a string" : See {@link Src/Parameters/String.LisioStringParameter | LisioStringParameter}
 *  * "My parameter will be saved as a boolean" : See {@link Src/Parameters/Boolean.LisioBooleanParameter | LisioBooleanParameter}
 *  * You may have none of this answer, in this case you have to ask you : "Can I simplify my datas format to use string, number or boolean ?"
 *    * If "yes" all is well
 *    * If "no", create your new parameter type extend {@link LisioParameter | LisioParameter} and add this new class in type {@link LisioParameterNames | LisioParameterNames}
 *
 * ## How to modify a parameter ? Part 1
 *
 * First of all, you need to identify what is the type of your parameter.\
 * To do so, you have to ask you : "In what form my parameter is saved ?"\
 * Now depending on your answer you have multiple choices :
 *  * "My parameter is saved as a number" : See {@link Src/Parameters/Numeric.LisioNumericParameter | LisioNumericParameter}
 *  * "My parameter is saved as a string" : See {@link Src/Parameters/String.LisioStringParameter | LisioStringParameter}
 *  * "My parameter is saved as a boolean" : See {@link Src/Parameters/Boolean.LisioBooleanParameter | LisioBooleanParameter}
 *
 * ## How to delete a parameter ? Part 1
 *
 * First of all, you need to identify what is the type of your parameter.\
 * To do so, you have to ask you : "In what form my parameter is saved ?"\
 * Now depending on your answer you have multiple choices :
 *  * "My parameter is saved as a number" : See {@link Src/Parameters/Numeric.LisioNumericParameter | LisioNumericParameter}
 *  * "My parameter is saved as a string" : See {@link Src/Parameters/String.LisioStringParameter | LisioStringParameter}
 *  * "My parameter is saved as a boolean" : See {@link Src/Parameters/Boolean.LisioBooleanParameter | LisioBooleanParameter}
 *
 * ## Documentation
 *
 * Abstract class representing a parameter.\
 * It aims to centralize all the logic of a parameter.\
 * To execute his responsability this class does :
 *  * Saves name and value of a parameter
 *  * Formats parameter for message exchange
 */
class LisioParameter {
    /**
     * Protected attribute to store name of parameter
     * @source
     */
    _name;
    /**
     * Getter for attribute {@link _name | _name}
     * @returns Returns _name attribute
     * @source
     */
    get name() {
        return this._name;
    }
    /**
     * Public method to parse user
     * @returns Returns parsed parameter
     * @source
     */
    formatForSaving() {
        return {
            name: this._name,
            value: this._value,
        };
    }
    /**
     * Constructor of class {@link LisioParameterNames | LisioParameterNames}
     * @param {LisioParameterNamesNames} name - Parameter name
     * @source
     */
    constructor(name) {
        this._name = name;
    }
}
export { LisioParameter };
